import React from 'react';

import FormalizationOption from '../components/FormalizationOption';

const FormalizationOptionPage = () => {
  return <FormalizationOption />;
};

export default FormalizationOptionPage;
